var render = function render(){var _vm=this,_c=_vm._self._c;return _c('img',{staticClass:"img-media",attrs:{"alt":_vm._f("strippedContent")(_vm.alt),"src":_vm.urlImg + '/' + _vm.src,"loading":"lazy"}})
}
var staticRenderFns = []

export { render, staticRenderFns }